module.exports = __webpack_public_path__ + "img/EdgeBrowser.22e028c1.svg";